module.exports = __webpack_public_path__ + "img/uber_eats.09719169.png";